import PhpRedirector, { WhatsappRedirector, PreTrialRedirector } from '../../components/utils/PhpRedirector';

export const PhpRedirectorPage = () => {
    return <PhpRedirector />;
  };

  export const WhatsappRedirectorPage = () => {
    return <WhatsappRedirector />;
  }

  export const PreTrialRedirectorPage = ({ channel }) => {
    return <PreTrialRedirector channel={channel} />;
  }
